import { render, staticRenderFns } from "./ExaminationInfo.vue?vue&type=template&id=efec53d8&"
import script from "./ExaminationInfo.vue?vue&type=script&lang=js&"
export * from "./ExaminationInfo.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationInfo.vue?vue&type=style&index=0&id=efec53d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports